var map = {
	"./certificate1.png": "46ba",
	"./certificate2.png": "960d",
	"./certificate3.png": "3d43",
	"./certificate4.png": "1671",
	"./certificate5.png": "4a80",
	"./certificate6.png": "8222",
	"./certificate7.png": "1534",
	"./certificate8.png": "0e3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8459";